export const initializeJobs = () => {
  const lists = document.querySelectorAll('[data-component="jobs-list"]')

  lists.forEach(list => {
    const cards = Array.from(list.querySelectorAll('[data-component="jobs-card"]'))
    const resetButton = list.querySelector('[data-component="jobs-reset"]')
    const employmentTypeSelect = list.querySelector('[data-component="jobs-filter-employment-type"]')
    const careerLevelSelect = list.querySelector('[data-component="jobs-filter-career-level"]')
    const emptyMessage = list.querySelector('[data-component="jobs-empty"]')

    const matchesFilters = card => {
      const employmentTypes = (card.dataset.employmentType || '').split(',').filter(Boolean)
      const careerLevels = (card.dataset.careerLevel || '').split(',').filter(Boolean)
      const employmentType = employmentTypeSelect?.value || ''
      const careerLevel = careerLevelSelect?.value || ''
      const employmentTypeMatch = !employmentType || employmentTypes.includes(employmentType)
      const careerLevelMatch = !careerLevel || careerLevels.includes(careerLevel)
      return employmentTypeMatch && careerLevelMatch
    }

    const updateResetState = () => {
      const isActive = !employmentTypeSelect?.value && !careerLevelSelect?.value
      if (resetButton) {
        resetButton.dataset.active = isActive ? 'true' : 'false'
      }
    }

    const render = () => {
      const matched = cards.filter(matchesFilters)

      cards.forEach(card => {
        card.classList.toggle('hidden', !matched.includes(card))
      })

      if (emptyMessage) {
        emptyMessage.classList.toggle('hidden', matched.length > 0)
      }

      updateResetState()
    }

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        if (employmentTypeSelect) employmentTypeSelect.value = ''
        if (careerLevelSelect) careerLevelSelect.value = ''
        render()
      })
    }

    employmentTypeSelect?.addEventListener('change', render)
    careerLevelSelect?.addEventListener('change', render)

    render()
  })
}
